<template>
	<div class="form-template">
		
		<div>
			<ul id="list-items-check-top" class="list-items-check mb30">
				<li class="d-inline b-radius3 b-right f-weight" >Доступно: {{ countcopywriters }}</li>

				<li class="d-inline b-radius3 c-pointer list-items-check-li background-white" :class="{ itemActive: activeUser == 0 }"  @click="activeUser = 0">За всички </li>

				<li v-for="(item, index) in copywriters" :key="item.id" class="d-inline b-radius3 c-pointer list-items-check-li background-white" :class="{ itemActive: activeUser == item.id }" @click="activeUser = item.id">{{ item.name }} </li>
				
			</ul>


			<div class="textarea-div">
				<textarea class="textarea" placeholder="" v-model="explanation" ></textarea>
				<span class="footer-input">Описание | Символи: {{ countChars(explanation) }}</span>
			</div>

			<div class="input-div">
				<input type="text" class="input" v-model="price">
				<span class="footer-input">Цена за 100 думи </span>
			</div>

			<form action="" id="botton-send-server" @submit.prevent="sendToServer">
				<button  type="submit" class="success-button active-success-button" >Готово</button>
			</form>

		</div>

	</div>
</template>	

<script>
	
	import axios from 'axios'
    import General from '../../../../mixins/system/general'

	export default {
		name: 'create-task-copyright',
		props: {
			checkBoxValue: {
				type: Array,
			}
		},
		data() {
			return {
				explanation:'2',
				copywriters: [],
				activeUser:0,
				price: 2.4
			}
		},

		created() {


			axios.get(this.$store.getters.getDomainName+ 'users/copywriters')

			.then(response => {
				this.copywriters = response.data
			})
			
			.catch(error => { })
		},

		methods: {
			sendToServer() {

				axios.post(this.$store.getters.getDomainName+'task', {
					products: this.checkBoxValue,
					user_id: this.activeUser,
					explanation: this.explanation,
					price: this.price,
				})

				.then(response => {

					this.items = response.data

                    this.showAlertSuccess('Done', response.data)

					this.$emit('done', response.data)

			})
				.catch(error => { 
                    this.showAlertError('Error', error.response.data)
					
					this.$emit('done', error.response.data)


					
				})

			},
			countChars(string) {
				return string.length
			}
		},
		computed: {
			countcopywriters() {
				return this.copywriters.length
			}
		},
      mixins: [General],

	}

</script>

<style scoped>
.itemActive {
	border:1px solid #1473e6!important;
}
.list-items-check{ margin-top:20px;}
.list-items-check li{border-radius:3px; padding:3px 10px;font-size:11px; }
.list-items-check-li {
	border:1px solid  hsl(0, 0%, 90%);
	margin-right: 15px;
}
#botton-send-server {
	text-align: right;
}
.success-button {
	border: 2px solid #1473e6;
	background: #1473e6!important;
	color: #fff;
	border-radius: 19px;
	padding: 4px 10px 6px;
	font-weight: 500;
	font-size: 14px;
	margin-left: 15px;
}
.form-template{
	height: 250px;
	margin: 10px 0 20px;
}
.input-div{
	margin-bottom:30px;width: 47.5%;float:left;margin-right:1.4%; 
	display: inline-block;
}
.input{
	color: #6c757d;
	font-size: 12px;
	margin: 0!important;display:block;width:100%;font-size:13px;height:34px;line-height:10px;border-width:1px 0px;border-top:1px solid transparent;border-bottom:1px solid rgb(226, 226, 226);outline:none
}
.textarea {  
	color: #6c757d;
	font-size: 12px;
	margin: 0!important;
	display: block;
	width: 100%;
	border-radius: 2px ;
	padding: 10px;
	font-size: 13px;
	height: auto;
	min-height: 100px;
	line-height: 18px;
	border-width: 1px 0px;
	border-top: 1px solid transparent;
	border: 1px solid rgb(226, 226, 226);
	outline: none;}
	.footer-input{display:block;font-size:11px;color:rgb(193, 193, 193);    color: #006886;

		font-weight: 600;}


		input::placeholder { /* Chrome/Opera/Safari */
			color: #cacaca;
		}
		textarea::placeholder { /* Chrome/Opera/Safari */
			color: #cacaca;
		}

	</style>



// WEBPACK FOOTER //
// src/components/layouts/forms/copyright/createTask.vue